export default "__VITE_ASSET__DuSO1_mv__"